import { createSelector } from 'reselect'

const testReducerDataSelector = state => state.testReducer.getIn(["data"]).toJS()
export const testDataSelector = createSelector(
    testReducerDataSelector, (dataField) => {      
      return {
        testData: dataField.testData
      }
    }
  )